module.exports = __webpack_public_path__ + "static/westjet-0b324cd6478eda38de3ba1ea2df3671f.png";